import React, { useEffect, useState } from 'react'
import parse from 'html-react-parser'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getBlogCategoryData, getBlogDetailData, getLatestBlogData } from '../../../../Redux/action/MasterAction';
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';
import FeedbackForm from '../../../FeedbackForm/FeedbackForm';
import SkeletonLoaderBlogPage from '../../../../Common/skeleton/Blog/SkeletonLoaderBlogPage';



const host = process.env.REACT_APP_API_SERVER
const BlogDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();



  const { name } = useParams();

  useEffect(() => {
    dispatch(getBlogDetailData(name));
    dispatch(getLatestBlogData())
    dispatch(getBlogCategoryData());
  }, [name]);

  const {
    loadingBlogDetailDataListApi,
    BlogDetailDataListApiData,
    BlogDetailDataListApiError,


    loadingBlogCategoryDataListApi,
    BlogCategoryDataListApiData,
    BlogCategoryDataListApiError,

    loadingLatestBlogDataListApi,
    LatestBlogDataListApiData,
    LatestBlogDataListApiError,


  } = useSelector(state => state?.MasterReducer);

  return (

    <div>
      <FeedbackForm />
      <Header />
      <section className="blogs">
        <div className="container">
         { loadingBlogDetailDataListApi ?
         <SkeletonLoaderBlogPage/>
         :
         <div className="content" style={{ transform: "none", minHeight: 24 }}>
            <div className="container-fluid" style={{ transform: "none" }}>
              <div className="row" style={{ transform: "none" }}>
                <div className="col-lg-8 col-md-12">


                  <div className="blog" >
                    <div className="blog-image">
                      <img
                        className="img-fluid"
                        src={BlogDetailDataListApiData?.image ? `${host}${BlogDetailDataListApiData?.image}` : ""}
                        alt="Post Image"
                      />
                    </div>
                    <h3 className="blog-title">{BlogDetailDataListApiData?.title}</h3>
                    <div className="blog-info clearfix">
                      <div className="post-left">
                        <ul>
                          {/* <li>
                                                            <div className="post-author">
                                                                <a href="profile.html">
                                                                    <img
                                                                        src="	https://mentoring.dreamstechnologies.com/html/template/assets/img/user/user.jpg"
                                                                        alt="Post Author"
                                                                    />{" "}
                                                                    <span>Ruby Perrin</span>
                                                                </a>
                                                            </div>
                                                        </li> */}
                          <li>
                            <i className="far fa-clock" />{new Date(BlogDetailDataListApiData?.createdAt).toDateString()}
                          </li>
                          {/* <li>
                                                            <i className="far fa-comments" />
                                                            12 Comments
                                                        </li> */}
                          <li>
                            <i className="fa fa-tags" />
                            {BlogDetailDataListApiData?.category?.name}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="blog-content">
                      {BlogDetailDataListApiData?.description ? parse(BlogDetailDataListApiData?.description) : ''}
                    </div>
                  </div>



                </div>
                <div
                  className="col-lg-4 col-md-12 sidebar-right theiaStickySidebar"
                  style={{
                    position: "relative",
                    overflow: "visible",
                    boxSizing: "border-box",
                    minHeight: 1
                  }}
                >
                  <div
                    className="theiaStickySidebar"
                    style={{
                      paddingTop: 0,
                      paddingBottom: 1,
                      position: "static",
                      transform: "none",
                      top: 0,
                      left: "1018.79px"
                    }}
                  >
                    <div className="blog">
                      <div className="card post-widget">
                        <div className="card-header">
                          <h4 className="card-title">Latest Posts</h4>
                        </div>
                        <div className="card-body">
                          <ul className="latest-posts">
                            {LatestBlogDataListApiData?.map((data) => (
                              <Link to={`/blog-detail/${data?.slug}`}>
                                <li key={data?.id}>
                                  <div className="post-thumb">
                                    <a>
                                      <img
                                        className="img-fluid"
                                        src={data?.image ? `${host}${data?.image}` : ""}
                                        alt=""
                                      />
                                    </a>
                                  </div>
                                  <div className="post-info">
                                    <h4>
                                      <a>
                                        {data?.title}
                                      </a>
                                    </h4>
                                    <p>{new Date(data?.createdAt).toDateString()}</p>
                                  </div>
                                </li></Link>
                            ))}


                          </ul>
                        </div>
                      </div>

                    </div>
                    <div className="card category-widget">
                      <div className="card-header">
                        <h4 className="card-title">Blog Categories</h4>
                      </div>
                      <div className="card-body">
                        <ul className="categories">
                          {BlogCategoryDataListApiData?.map((data) => (
                            <li key={data?.id}>
                              <a >
                                {data?.name} <span>({data?.blogCount})</span>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default BlogDetail